var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import useBrowserAuthMe from '../../hooks/useBrowserAuthMe';
import useLatestUnreadConversationList from '../../hooks/conversation/useLatestUnreadConversationList';
import './index.less';
var IconLink = function (props) {
    var iconName = props.iconName, children = props.children, className = props.className, other = __rest(props, ["iconName", "children", "className"]);
    return React.createElement("a", __assign({}, other, { className: classNames('iconlink', className) }),
        React.createElement("i", { className: "fas " + iconName, "aria-hidden": true }),
        React.createElement("span", { className: "iconlink__label" }, children));
};
var UnreadMessagesIcon = function (props) {
    var children = props.children, className = props.className, length = props.length, other = __rest(props, ["children", "className", "length"]);
    return React.createElement("a", __assign({}, other, { className: classNames('iconlink', className) }),
        React.createElement("p", { className: "messagelink-wrapper", "aria-label": length + " uleste meldinger" },
            React.createElement("i", { className: "fas fa fa-comments", "aria-hidden": true }),
            React.createElement("span", { className: "unreadmessages" }, length)),
        React.createElement("span", { className: "iconlink__label" }, children));
};
var MyConversations = function () {
    var user = useBrowserAuthMe().user;
    var pathname = window.location.pathname;
    var hasHigherRefreshRate = !pathname.includes('/chat');
    var conversations = useLatestUnreadConversationList(user, hasHigherRefreshRate).conversations;
    var hasUnreadConversations = !conversations || conversations.length === 0;
    if (hasUnreadConversations) {
        return React.createElement(IconLink, { href: "/chat", iconName: "fa fa-comments", className: "button pagelinks__link" }, "Mine samtaler");
    }
    return React.createElement(UnreadMessagesIcon, { href: "/chat", className: "button pagelinks__link", length: conversations.length }, "Mine samtaler");
};
var MyPageLink = function (_a) {
    var isLoggedIn = _a.isLoggedIn;
    if (!isLoggedIn) {
        return React.createElement(IconLink, { href: "/logg_inn", iconName: "fa-sign-in-alt", className: "button pagelinks__link" }, "Logg inn");
    }
    return React.createElement(IconLink, { href: "/min_side", iconName: "fa-user", className: "button pagelinks__link" }, "Min side");
};
var PrimaryNavItems = function (_a) {
    var isLoggedIn = _a.isLoggedIn;
    return React.createElement("nav", { className: "pagelinks" },
        React.createElement(IconLink, { href: "/sett_inn_annonse", iconName: "fa-plus", className: "button pagelinks__link" }, "Opprett annonse"),
        isLoggedIn && React.createElement(MyConversations, null),
        React.createElement(MyPageLink, { isLoggedIn: isLoggedIn }));
};
var BookSearchForm = function () { return React.createElement("form", { action: "/sok", method: "get", className: "search search--with-scan pageheader__searchform" },
    React.createElement("input", { type: "search", name: "query", className: "autocomplete ui-autocomplete-input", placeholder: "S\u00F8k etter bok, fag eller ISBN", autoComplete: "off", role: "textbox", "aria-autocomplete": "list", "aria-haspopup": "true" }),
    React.createElement("button", { type: "submit", title: "S\u00F8k etter bok" },
        React.createElement("img", { src: "/static/img/search.svg", alt: "search" })),
    React.createElement("a", { href: "/strekkode", className: "button pageheader__scanlink", title: "Scan strekkode", "aria-label": "Scan strekkode" },
        React.createElement("i", { className: "fas fa-barcode fa-2x", "aria-hidden": true }))); };
var Header = function (_a) {
    var isLoggedIn = _a.isLoggedIn, isWelcomePage = _a.isWelcomePage;
    if (isWelcomePage) {
        return React.createElement(React.Fragment, null,
            React.createElement("a", { href: "/", "aria-label": "G\u00E5 tilbake til startsiden", className: "pagelogo" },
                React.createElement("img", { src: "/static/img/ibok_logo_green.svg", alt: "ibok.no", className: "logo pagelogo__image" })),
            React.createElement(PrimaryNavItems, { isLoggedIn: isLoggedIn }));
    }
    return React.createElement(React.Fragment, null,
        React.createElement("a", { href: "/", "aria-label": "G\u00E5 tilbake til startsiden", className: "pagelogo" },
            React.createElement("img", { src: "/static/img/ibok_logo_green.svg", alt: "ibok.no", className: "logo pagelogo__image" })),
        React.createElement(BookSearchForm, null),
        React.createElement(PrimaryNavItems, { isLoggedIn: isLoggedIn }));
};
export default Header;
